import axios from "axios";
import React, { useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

export const getUserRole = (token) => {
  try {
    const decoded = jwtDecode(token);
    console.log("Decoded JWT:", decoded);

    const roles = decoded.roles || [];   // roles array from token
    const userName = decoded.userName || decoded.sub || null; // subject claim

    // Expiration (exp is in seconds, convert to ms)
    const expiryTime = decoded.exp ? decoded.exp * 1000 : null;

    return { roles, userName, expiryTime };
  } catch (error) {
    console.error("Invalid token", error);
    return { roles: [], userName: null, expiryTime: null };
  }
};

const EmployeeReson = ({ onCreated }) => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
     reason: "",
    notes: "",
  });

  const [errors, setErrors] = useState({});
const [loading, setLoading] = useState(false);
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.reason) {
      newErrors.reason = "Reason for leaving is required";
    }

    if (!formData.notes  || formData.notes.trim() === "") {
      newErrors.notes  = "Please add additional notes";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


const token = localStorage.getItem("token");
const decoded = jwtDecode(token);

console.log("emp id checking : ",decoded.employeeId)

  const handleSubmit = async () => {
  if (!validateForm()) return;

  try {
    setLoading(true);

    // const token = localStorage.getItem("token");

    const payload = {
      employeeId: decoded.employeeId,
      offboardingType: "RESIGNATION",
      reason: formData.reason,
      additionalNotes: formData.notes,
      comments: "Offboarding request created by employee"
      // ❌ lastWorkingDay NOT sent
    };

     const response =await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/api/v1/offboarding/create`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );

    toast.success("Offboarding request created successfully");
    onCreated(response.data.requestId);
    // navigate("/exit-interview-quetions");

  } catch (error) {
    console.error("Create offboarding failed", error);
    toast.error(
      error?.response?.data?.message || "Failed to create offboarding request"
    );
  } finally {
    setLoading(false);
  }
};


  return (
    <div className="col-md-4">
      <div className="offboarding-card">
        <h6 className="card-heading-secondary mt-4">
          Create My Offboarding
        </h6>

       
        <div className="mb-3">
          <label className="form-label labels">
            Reason for Leaving <span className="text-danger">*</span>
          </label>

          <select
            className="form-select custom-input2"
            name="reason"
            value={formData.reason}
            onChange={handleChange}
          >
            <option value="">Select reason</option>
            <option value="Personal Reason">Personal Reason</option>
            <option value="Career Growth">Career Growth</option>
            <option value="Relocation">Relocation</option>
          </select>

          {errors.reason && (
            <p className="error-text">{errors.reason}</p>
          )}
        </div>

        {/* Notes */}
        <div className="mb-4">
          <label className="form-label labels">Additional Notes</label>
          <textarea
            className="form-control custom-input"
            rows="3"
              name="notes"
            placeholder="Add any additional information"
            value={formData.notes}
            onChange={handleChange}
          />

          {errors.notes && (
            <p className="error-text">{errors.notes}</p>
          )}
        </div>

        {/* Buttons */}
        <div className="d-flex gap-4 mb-5">
          <button className="cancel-btn">Cancel</button>
          
          <button
            className="create-btn111"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? "Creating..." : "Create Request"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EmployeeReson;